{
  "name": "@ns/company-data-offer-answer",
  "version": "1.2.0",
  "requiredPermission": "DATA_SHARING_ACCEPT",
  "description": "Accept or decline data another company offered to share",
  "inputs": {
    "GRANT_ID": {
      "type": "string"
    },
    "RELATIONSHIP_ID": {
      "type": "string"
    }
  },
  "outcomes": {
    "answered": {
      "serverOnly": true
    }
  }
}
